var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_317)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_839_317)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_839_317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 0H16C7.16344 0 0 7.16344 0 16V44C0 52.8366 7.16344 60 16 60H44C52.8366 60 60 52.8366 60 44V16C60 7.16344 52.8366 0 44 0Z",
    fill: "#D8CAFF"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M18.06 34.72C19.34 33.6533 20.36 32.7667 21.12 32.06C21.88 31.34 22.5133 30.5933 23.02 29.82C23.5267 29.0467 23.78 28.2867 23.78 27.54C23.78 26.86 23.62 26.3267 23.3 25.94C22.98 25.5533 22.4867 25.36 21.82 25.36C21.1533 25.36 20.64 25.5867 20.28 26.04C19.92 26.48 19.7333 27.0867 19.72 27.86H17C17.0533 26.26 17.5267 25.0467 18.42 24.22C19.3267 23.3933 20.4733 22.98 21.86 22.98C23.38 22.98 24.5467 23.3867 25.36 24.2C26.1733 25 26.58 26.06 26.58 27.38C26.58 28.42 26.3 29.4133 25.74 30.36C25.18 31.3067 24.54 32.1333 23.82 32.84C23.1 33.5333 22.16 34.3733 21 35.36H26.9V37.68H17.02V35.6L18.06 34.72Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1166 24.1362C32.9086 24.1362 33.5486 24.3882 34.0366 24.8922C34.5246 25.3882 34.7686 26.0842 34.7686 26.9802V30.8802H33.0886V27.2082C33.0886 26.6802 32.9566 26.2762 32.6926 25.9962C32.4286 25.7082 32.0686 25.5642 31.6126 25.5642C31.1486 25.5642 30.7806 25.7082 30.5086 25.9962C30.2446 26.2762 30.1126 26.6802 30.1126 27.2082V30.8802H28.4326V24.2322H30.1126V25.0602C30.3366 24.7722 30.6206 24.5482 30.9646 24.3882C31.3166 24.2202 31.7006 24.1362 32.1166 24.1362Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2939 27.532C36.2939 26.86 36.4259 26.264 36.6899 25.744C36.9619 25.224 37.3299 24.824 37.7939 24.544C38.2579 24.264 38.7739 24.124 39.3419 24.124C39.7739 24.124 40.1859 24.22 40.5779 24.412C40.9699 24.596 41.2819 24.844 41.5139 25.156V22H43.2179V30.88H41.5139V29.896C41.3059 30.224 41.0139 30.488 40.6379 30.688C40.2619 30.888 39.8259 30.988 39.3299 30.988C38.7699 30.988 38.2579 30.844 37.7939 30.556C37.3299 30.268 36.9619 29.864 36.6899 29.344C36.4259 28.816 36.2939 28.212 36.2939 27.532ZM41.5259 27.556C41.5259 27.148 41.4459 26.8 41.2859 26.512C41.1259 26.216 40.9099 25.992 40.6379 25.84C40.3659 25.68 40.0739 25.6 39.7619 25.6C39.4499 25.6 39.1619 25.676 38.8979 25.828C38.6339 25.98 38.4179 26.204 38.2499 26.5C38.0899 26.788 38.0099 27.132 38.0099 27.532C38.0099 27.932 38.0899 28.284 38.2499 28.588C38.4179 28.884 38.6339 29.112 38.8979 29.272C39.1699 29.432 39.4579 29.512 39.7619 29.512C40.0739 29.512 40.3659 29.436 40.6379 29.284C40.9099 29.124 41.1259 28.9 41.2859 28.612C41.4459 28.316 41.5259 27.964 41.5259 27.556Z",
    fill: "#2A2A2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_839_317",
    x: -3,
    y: -3,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_839_317"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_839_317",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_839_317",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_839_317"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecound);
export default __webpack_public_path__ + "static/media/secound.e7e0db4706d05f6221de46c29dedd664.svg";
export { ForwardRef as ReactComponent };